import { useTranslation } from 'react-i18next';
import { useACHLocationForm } from 'components/forms/ach-copy-location-form/ach-copy-location-form.hooks';
import ACHCopyLocationForm from 'components/forms/ach-copy-location-form/ach-copy-location-form.component';
import { useCopyACHLocationMutation } from 'api/giftcard-ach-service/giftcard-ach-service';
import { useNavigate } from 'react-router-dom';
import FormDrawer from 'components/drawers/form-drawer/form-drawer.component';

type ACHCopyToDrawerProps = {
  open: boolean;
  close: () => void;
  locationId: string;
};

const ACHCopyToDrawer = ({ open, close, locationId }: ACHCopyToDrawerProps) => {
  const { t } = useTranslation();
  const { form } = useACHLocationForm();
  const navigate = useNavigate();
  const [copyACHLocation, { isLoading }] = useCopyACHLocationMutation();
  const submit = async data => {
    await copyACHLocation({
      fromLocationId: locationId,
      toLocationId: data.location,
    });
    close();
    navigate(`/giftcards/moneymovement/${data.location}`);
  };

  const cancel = () => {
    close();
  };

  return (
    <FormDrawer
      title={t('drawer.copyACHSettings.title')}
      subtitle={t('drawer.copyACHSettings.copyTo.subtitle')}
      data-testid="ACHCopyToDrawer.Drawer"
      open={open}
      onClose={cancel}
      onValid={submit}
      cancel={cancel}
      formMethods={form}
      submitButtonLabel={t('drawer.copyACHSettings.submitLabel')}
      isLoading={isLoading}
    >
      <ACHCopyLocationForm
        label={t('drawer.copyACHSettings.copyTo.autocomplete.label')}
        data-testid="ACHCopyToDrawer.AutocompleteField"
      />
    </FormDrawer>
  );
};

export default ACHCopyToDrawer;
